import React, { useEffect, useState, useReducer } from 'react';
import '../../Assets/css/view.css';
import TaskPoints from './TaskPoints';
import ActivityLog from './ActivityLog';
import getData from "../../Custome_Components/commonAPISelect";
import getData2 from "../../Custome_Components/commonAPISelect2";
import { toast } from "react-toastify";
import { IoCloseOutline } from "react-icons/io5";
import { FiBarChart } from "react-icons/fi";
import { HiOutlineCalendar } from "react-icons/hi2";
import { FiLayers } from "react-icons/fi";
import { MdOutlineSubdirectoryArrowRight } from "react-icons/md";
import { FiMail } from "react-icons/fi";
import { FiPhone } from "react-icons/fi";
import { PiNotePencil } from "react-icons/pi";
import { BsBarChartSteps } from "react-icons/bs";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { PiFilePdfThin } from "react-icons/pi";
import { PiFileTxtThin } from "react-icons/pi";
import { PiFileXlsThin } from "react-icons/pi";
import { PiFileDocThin } from "react-icons/pi";
import { MdRemoveRedEye } from "react-icons/md";
import { IoIosAdd } from "react-icons/io";
import { AiOutlineClose } from "react-icons/ai";
import { FiFlag } from "react-icons/fi";
import { Button } from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: '14px',
    },
}));

const departmentReducer = (state, action) => {
    switch (action.type) {
        case "TaskStatusIDPK":
            return { ...state, TaskStatusIDPK: action.payload };
        case "TaskStatus":
            return { ...state, TaskStatus: action.payload };
        default:
            return state;
    }
};

const initialState = {
    TaskStatusIDPK: '',
    TaskStatus: ''
}

const View = (props) => {
    const { handleViewModalClose, Data, Modalloading } = props;
    const [state, dispatch] = useReducer(departmentReducer, initialState);
    const [StatusList, setStatusList] = useState([]);
    const [isStatusOpen, setIsStatusOpen] = useState(false);

    const [ClientAttachDatas, setClientAttachDatas] = useState([]);
    const [ClientAttachDatasView, setClientAttachDatasView] = useState(false);
    const [ClientAttachImgFiles, setClientAttachImgFiles] = useState([]);
    const [ClientConvertedAttachs, setClientConvertedAttachs] = useState([]);

    const [DevAttachDatas, setDevAttachDatas] = useState([]);
    const [DevAttachDatasView, setDevAttachDatasView] = useState(false);
    const [DevAttachImgFiles, setDevAttachImgFiles] = useState([]);
    const [DevConvertedAttachs, setDevConvertedAttachs] = useState([]);

    useEffect(() => {
        AttachmentHandle();
        handleStatusList();
        dispatch({ type: 'TaskStatusIDPK', payload: Data.ClientTestIDPK ?? null });
        dispatch({ type: 'TaskStatus', payload: Data.ClientTestName ?? null });
    }, [Data.ComplaintIDPK])

    useEffect(() => {
        if (ClientAttachImgFiles && ClientAttachImgFiles.length > 0) {
            convertFilesToBase64(ClientAttachImgFiles)
                .then((result) => {
                    setClientConvertedAttachs(result);
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    }, [ClientAttachImgFiles]);

    useEffect(() => {
        if (DevAttachImgFiles && DevAttachImgFiles.length > 0) {
            convertFilesToBase64(DevAttachImgFiles)
                .then((result) => {
                    setDevConvertedAttachs(result);
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    }, [DevAttachImgFiles]);

    const handleStatusList = async () => {
        const response = await getData("VwAPINSEIPLClientPortal/", {
            data: {
                p1_int: 12,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const { Output: { status, data } } = response;
        if (response.Output.status.code == "200") {
            setStatusList(data || []);
        } else {
            console.error("Error fetching data:", status.message);
        }
    };

    const handleStatusSave = async (StatusId) => {
        const response = await getData("VwAPINSEIPLClientPortal/", {
            data: {
                p1_int: 13,
                p2_int: Data.ComplaintIDPK ? Number(Data.ComplaintIDPK) : null,
                p3_int: StatusId ? Number(StatusId) : null,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const { Output: { status } } = response;
        if (response.Output.status.code == "200") {
            toast.success("Task status updated successfully");
        } else {
            console.error("Error fetching data:", status.message);
        }
    };

    const convertFilesToBase64 = (files) => {
        return Promise.all(
            files.map((file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();

                    const getFileType = (type, name) => {
                        if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                            return "xlsx";
                        }
                        if (name.toLowerCase().endsWith(".sql")) {
                            return "txt";
                        }
                        if (!type || type === "") {
                            return "txt";
                        }
                        return name.split(".").pop();
                    };
                    reader.onload = (event) => {
                        const base64data = event.target.result.split(",")[1];
                        resolve({
                            base64data,
                            filename: file.name,
                            type: getFileType(file.type, file.name),
                        });
                    };
                    reader.onerror = (error) => reject(error);
                    if (!file.type || file.type === "") {
                        file = new File([file], `${file.name}.txt`, { type: "text/plain" });
                    }
                    reader.readAsDataURL(file);
                });
            })
        );
    };

    const handleFilePreviewView = (fileData) => {
        if (!fileData || !fileData.ImgPath) {
            alert("No file available for preview.");
            return;
        }

        const fileUrl = fileData.ImgPath;
        const fileExtension = fileUrl.split('.').pop().toLowerCase();

        const supportedFormats = [
            "pdf",
            "jpg",
            "jpeg",
            "png",
            "doc",
            "docx",
            "xlsx",
            "txt",
            "sql",
            // ✅ video formats
            "mp4",
            "webm",
            "ogg",
            "mov",
            "avi",
            "mkv"
        ];

        if (!supportedFormats.includes(fileExtension)) {
            alert("File format not supported for preview.");
            return;
        }

        const browserPreviewFormats = [
            "pdf",
            "jpg",
            "jpeg",
            "png",
            "mp4",
            "webm",
            "ogg"
        ];

        if (browserPreviewFormats.includes(fileExtension)) {
            window.open(fileUrl, "_blank");
        } else {
            window.open(fileUrl, "_blank");
        }
    };

    const convertedImageName = (ImageName) => {
        const filename = ImageName;
        const extension = filename.split('.').pop();
        return extension;
    }

    const ClientAttactFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        setClientAttachImgFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const ClientAttactRemoves = (fileName) => {
        setClientAttachImgFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    const DevAttactFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        setDevAttachImgFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const DevAttactRemoves = (fileName) => {
        setDevAttachImgFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
    };

    const handleFilePreview = (file) => {
        if (file.type.startsWith("image/")) {
            const url = URL.createObjectURL(file);
            window.open(url, "_blank");
        } else if (file.type === "application/pdf") {
            const url = URL.createObjectURL(file);
            window.open(url, "_blank");
        } else {
            alert("Preview not supported for this file type");
        }
    };

    async function AttachSave(ImageArray, TaskIDPK, ImageCode) {
        const url = 'https://smartfm.in/NSEIPLWEBANDMOBILEPORTAL/imageupload.php';
        try {
            await Promise.all(ImageArray.map(async (param) => {
                const requestOptions = {
                    method: 'POST',
                    body: JSON.stringify(param),
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                const response = await fetch(url, requestOptions);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const responseData = await response.json();
                const imagePath = responseData.filename;
                const url2 = 'https://smartfm.in/NSEIPLWEBANDMOBILEPORTAL/AdminImageRegistry.php';
                const formData = {
                    "AdminImageIDPK_int": "",
                    "ImageCode_varchar": ImageCode ?? '',
                    "ImageName_varchar": param.filename,
                    "ImgActualSize_varchar": "",
                    "ImgCompressSize_varchar": "",
                    "ImageSource_image": "",
                    "ImgPath_varchar": imagePath,
                    "ImgType_varchar": "png",
                    "TransType_varchar": "",
                    "ImgProType_int": "",
                    "IsDefault_bit": "",
                    "IsDraft_bit": "",
                    "Remarks_varchar": "",
                    "TransID_int": Number(TaskIDPK),
                    "ModFormID_int": 1,
                    "TransTypeID_int": "",
                    "IsActive_bit": "1",
                    "DeleStat_bit": "",
                    "CreatedUserID_int": "",
                    "CreatedTtm_datetime": "",
                    "UpdatedUserID_int": "",
                    "UpdatedTtm_datetime": ""
                };
                const requestOptions2 = {
                    method: 'POST',
                    body: JSON.stringify(formData),
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                const response2 = await fetch(url2, requestOptions2);
                if (!response2.ok) {
                    throw new Error('Network response was not ok');
                }
            }));

            if (ImageCode === 7) {
                setDevAttachImgFiles([]);
                setDevConvertedAttachs([]);
            } else {
                setClientAttachImgFiles([]);
                setClientConvertedAttachs([]);
            }
            AttachmentHandle();
        } catch (error) {
            console.error('Error:', error);
        }
    }

    function ClientAttachViewFunction() {
        setClientAttachDatasView(!ClientAttachDatasView)
        if (!ClientAttachDatas) {
            toast.info('No client attachements found')
        }
    }

    function DevAttachViewFunction() {
        setDevAttachDatasView(!DevAttachDatasView)
        if (!DevAttachDatas) {
            toast.info('No development attachements found')
        }
    }

    const AttachmentHandle = async () => {
        const result = await getData2("DashboardService/VwAPINSEIPLDetails/", {
            data: {
                p1_int: 84,
                p2_int: Data.ComplaintIDPK ? Number(Data.ComplaintIDPK) : null,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const { Output: { status, data } } = result;
        if (status.code == "200") {
            const ClientAttachmentData = data && data.length > 0 && data.filter(item => item.ImageCode == "");
            const DevAttachmentData = data && data.length > 0 && data.filter(item => item.ImageCode == 7);

            if (ClientAttachmentData && ClientAttachmentData.length > 0) {
                setClientAttachDatas(ClientAttachmentData);
            }

            if (DevAttachmentData && DevAttachmentData.length > 0) {
                setDevAttachDatas(DevAttachmentData);
            }
        } else {
            console.error("Error fetching data:", status.message);
        }
    };

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <div className='TopBarStyle'>
                <div className='TopbarTaskCodeSec'>
                    <span className='TaskCodeLabel'>Task Code:</span>
                    <span className='TaskCodeData'>{Data.ComplaintNo ?? null}</span>
                </div>
                <IoCloseOutline className="IoCloseStyle" onClick={() => { handleViewModalClose(); setClientAttachImgFiles([]); setClientConvertedAttachs([]); setDevAttachImgFiles([]); setDevConvertedAttachs([]); }} />
            </div>
            <div className='ViewModalBodySec'>
                <div className='ViewTaskDetailsSec'>
                    <div className='TopbarTaskCodeSec'>
                        <span className='TaskCodeLabel'>Subject:</span>
                        <span className='TaskCodeData'>{Data.PortalSubject ?? null}</span>
                    </div>

                    <p className="TeskDes">
                        {Data.RequestDetailsDesc ?? null}
                    </p>

                    <div className="TaskDet">
                        <div className="TaskDetSub">
                            <div className="TaskLabelDiv">
                                <div className='TaskDetailIconParent'>
                                    <HiOutlineCalendar style={{ fontSize: "22px", color: "#666" }} />
                                </div>
                                <span className="TaskLabelText">Complained Date:</span>
                            </div>

                            <div className="TaskDataDiv">
                                <span className="TaskDataText">{Data.ComplainedDate ?? null}</span>
                            </div>
                        </div>

                        <div className="TaskDetSub">
                            <div className="TaskLabelDiv">
                                <div className='TaskDetailIconParent'>
                                    <BsBarChartSteps style={{ fontSize: "18px", color: "#666" }} />
                                </div>
                                <span className="TaskLabelText">Task Stage:</span>
                            </div>

                            <div className="TaskDataDiv">
                                <span className="TaskDataText">{Data.StageName ?? null}</span>
                            </div>
                        </div>

                        <div className="TaskDetSub">
                            <div className="TaskLabelDiv">
                                <div className='TaskDetailIconParent'>
                                    <FiFlag style={{ fontSize: "21px", color: "#666" }} />
                                </div>
                                <span className="TaskLabelText">Priority:</span>
                            </div>

                            <div className="TaskDataDiv">
                                <span className="TaskDataText" style={{
                                    color: Data.PriorityName.toLowerCase() === 'low' ? '#679436' :
                                        Data.PriorityName.toLowerCase() === 'medium' ? '#1976d2' :
                                            Data.PriorityName.toLowerCase() === 'high' ? '#d90429' :
                                                Data.PriorityName.toLowerCase() === 'critical' ? 'red' : null,
                                }}>{Data.PriorityName ?? null}</span>
                            </div>
                        </div>

                        <div className="TaskDetSub">
                            <div className="TaskLabelDiv">
                                <div className='TaskDetailIconParent'>
                                    <FiLayers style={{ fontSize: "20px", color: "#666" }} />
                                </div>
                                <span className="TaskLabelText">Department:</span>
                            </div>

                            <div className="TaskDataDiv">
                                <span className="TaskDataText">{Data.PortalDepartment ?? null}</span>
                            </div>
                        </div>

                        <div className="TaskDetSub">
                            <div className="TaskLabelDiv">
                                <div className='TaskDetailIconParent'>
                                    <MdOutlineSubdirectoryArrowRight style={{ fontSize: "22px", color: "#666" }} />
                                </div>
                                <span className="TaskLabelText">Request Type:</span>
                            </div>

                            <div className="TaskDataDiv">
                                <span className="TaskDataText">{Data.ClientReqName ?? null}</span>
                            </div>
                        </div>

                        <div className="TaskDetSub">
                            <div className="TaskLabelDiv">
                                <div className='TaskDetailIconParent'>
                                    <FiBarChart style={{ fontSize: "22px", color: "#666" }} />
                                </div>
                                <span className="TaskLabelText">Task Status:</span>
                            </div>

                            <div className="TaskDataDiv">
                                <span className="TaskDataText">{Data.TaskStatusName ?? null}</span>
                            </div>
                        </div>

                        <div className="TaskDetSub">
                            <div className="TaskLabelDiv">
                                <div className='TaskDetailIconParent'>
                                    <FiMail style={{ fontSize: "21px", color: "#666" }} />
                                </div>
                                <span className="TaskLabelText">Email:</span>
                            </div>

                            <div className="TaskDataDiv">
                                <span className="TaskDataText">{Data.Email ?? null}</span>
                            </div>
                        </div>

                        <div className="TaskDetSub">
                            <div className="TaskLabelDiv">
                                <div className='TaskDetailIconParent'>
                                    <FiPhone style={{ fontSize: "20px", color: "#666" }} />
                                </div>
                                <span className="TaskLabelText">Contact Number:</span>
                            </div>

                            <div className="TaskDataDiv">
                                <span className="TaskDataText">{Data.PhoneNo ?? null}</span>
                            </div>
                        </div>

                        <div className="TaskDetSub">
                            <div className="TaskLabelDiv">
                                <div className='TaskDetailIconParent'>
                                    <PiNotePencil style={{ fontSize: "24px", color: "#666" }} />
                                </div>
                                <span className="TaskLabelText">Client Status:</span>
                            </div>

                            <div className="NewTaskDataDiv">
                                <div className={state.TaskStatusIDPK == 1 ? 'SuccessInput' :
                                    state.TaskStatusIDPK == 2 ? 'FailInput' :
                                        state.TaskStatusIDPK == 3 ? 'DiscussionInput' :
                                        state.TaskStatusIDPK == 4 ? 'RetestInput' :
                                            " InputFieldMainDiv"} style={{ position: 'relative' }}>
                                    <input
                                        type="text"
                                        value={state.TaskStatus}
                                        onClick={() => { setIsStatusOpen((prevState) => !prevState); }}
                                        placeholder='Select Status'
                                        className={state.TaskStatusIDPK ? 'SelectStatusInput2' : 'SelectStatusInput1'}
                                        disabled={Data.StageName.toLowerCase() != "closed" ? true : false}
                                    />

                                    {isStatusOpen ? <IoIosArrowUp className={state.TaskStatusIDPK ? 'SelectStatusArrowIcon2' : 'SelectStatusArrowIcon1'} /> :
                                        <IoIosArrowDown className={state.TaskStatusIDPK ? 'SelectStatusArrowIcon2' : 'SelectStatusArrowIcon1'} />}

                                    {isStatusOpen && (
                                        <div
                                            className="SelectEmpDropDown"
                                        >
                                            {StatusList.length > 0 ? (
                                                StatusList.map((item) => (
                                                    <div
                                                        key={item.ClientTestIDPK}
                                                        onClick={() => {
                                                            dispatch({ type: 'TaskStatusIDPK', payload: item.ClientTestIDPK });
                                                            dispatch({ type: 'TaskStatus', payload: item.ClientTestName });
                                                            setIsStatusOpen(false);
                                                            handleStatusSave(item.ClientTestIDPK);
                                                        }}
                                                        className='SelectEmpDropDownList'
                                                    >
                                                        {item.ClientTestName}
                                                    </div>
                                                ))
                                            ) : (
                                                <div style={{ padding: '10px' }}>No results</div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className='TopbarTaskCodeSec' style={{ marginTop: "6px" }}>
                        <span className='TaskCodeLabel' style={{ fontSize: "14px" }}>Request Remarks:</span>
                        <span className='TaskCodeData' style={{ fontSize: "14px" }}>{Data.ClentOthersRemarks ?? null}</span>
                    </div>

                    <div style={{ width: "100%", marginTop: "16px", display: "flex", alignItems: "center", gap: "12px" }}>
                        <div className="AttachDiv" onClick={ClientAttachViewFunction}>
                            <span className="AttachCount">{ClientAttachDatas ? ClientAttachDatas.length : 0}</span>
                            <span className="AttchText">Client Attachment</span>
                            {(ClientAttachDatasView && ClientAttachDatas) ?
                                <IoIosArrowUp style={{ cursor: "pointer", color: "#222" }} />
                                : <IoIosArrowDown style={{ cursor: "pointer", color: "#222" }} />}
                        </div>

                        {state.TaskStatusIDPK != 1 && <Button variant="contained" className="NewAttchBtn">
                            <BootstrapTooltip title={"Add Attach"} placement="top-start">
                                <input
                                    type="file"
                                    multiple
                                    style={{ display: "none" }}
                                    id="TaskFileInput"
                                    onChange={(e) => ClientAttactFileChange(e)}
                                />

                                <label htmlFor="TaskFileInput" className="UpdateAttLabText">
                                    <IoIosAdd className='IoIosAddAttach' />
                                </label>
                            </BootstrapTooltip>
                        </Button>}

                        {ClientAttachImgFiles && ClientAttachImgFiles.length > 0 &&
                            <Button
                                variant="contained"
                                onClick={() => AttachSave(ClientConvertedAttachs, Data.ComplaintIDPK)}
                                className="TaskDetAdmUpdateBtn"
                            >
                                Save Attachments
                            </Button>}

                    </div>

                    {ClientAttachImgFiles && ClientAttachImgFiles.length > 0 &&
                        <div className="IssueImgFileList">
                            {ClientAttachImgFiles.map((file) => (
                                <div key={file.name} className="IssueTaskDetFileItem" onDoubleClick={() => handleFilePreview(file)}>
                                    <div className="TaskDetFileName">{file.name}</div>
                                    <AiOutlineClose className="TaskDetCloseIcon" onClick={() => ClientAttactRemoves(file.name)} />
                                </div>
                            ))}
                        </div>}

                    {ClientAttachDatasView && ClientAttachDatas &&
                        <div className="AttachDataSection">
                            {ClientAttachDatasView && ClientAttachDatas && ClientAttachDatas.map((val) => {
                                return (
                                    <div className="AttachDataDiv" key={val.ImageName}>
                                        <div className="AttachImgSection">
                                            {["jpg", "jpeg", "png"].includes(convertedImageName(val.ImgPath)) ?
                                                <img src={val.ImgPath} alt="Image" className="AttachImgStyle" />
                                                : ["pdf"].includes(convertedImageName(val.ImgPath)) ?
                                                    <div className="FileExtensionImgDiv"><PiFilePdfThin style={{ fontSize: "60px" }} /></div>
                                                    : ["txt"].includes(convertedImageName(val.ImgPath)) ?
                                                        <div className="FileExtensionImgDiv"><PiFileTxtThin style={{ fontSize: "60px" }} /></div>
                                                        : ["xlsx"].includes(convertedImageName(val.ImgPath)) ?
                                                            <div className="FileExtensionImgDiv"><PiFileXlsThin style={{ fontSize: "60px" }} /></div>
                                                            : ["docx"].includes(convertedImageName(val.ImgPath)) ?
                                                                <div className="FileExtensionImgDiv"><PiFileDocThin style={{ fontSize: "60px" }} /></div>
                                                                : ''}
                                        </div>
                                        <div className="AttachImgDetails">
                                            <BootstrapTooltip title={val.ImageName} placement="top-start">
                                                <span className="AttachImgName description-cell">{val.ImageName}</span>
                                            </BootstrapTooltip>
                                            <div className="AttachViewDiv" onClick={() => handleFilePreviewView(val)}>
                                                <MdRemoveRedEye style={{ width: '16px', height: "16px" }} />
                                                <span className="AttachViewtext">View</span>
                                            </div>
                                        </div>
                                    </div>);
                            })
                            }
                        </div>}

                    {/* *********** Development Attachments *********** */}
                    <div style={{ width: "100%", marginTop: "8px", display: "flex", alignItems: "center", gap: "12px" }}>
                        <div className="AttachDiv" onClick={DevAttachViewFunction}>
                            <span className="AttachCount">{DevAttachDatas ? DevAttachDatas.length : 0}</span>
                            <span className="AttchText">Development Attachment</span>
                            {(DevAttachDatasView && DevAttachDatas) ?
                                <IoIosArrowUp style={{ cursor: "pointer", color: "#222" }} />
                                : <IoIosArrowDown style={{ cursor: "pointer", color: "#222" }} />}
                        </div>

                        {/* <Button variant="contained" className="NewAttchBtn">
                            <BootstrapTooltip title={"Add Attach"} placement="top-start">
                                <input
                                    type="file"
                                    multiple
                                    style={{ display: "none" }}
                                    id="DevelopmentFileInput"
                                    onChange={(e) => DevAttactFileChange(e)}
                                />

                                <label htmlFor="DevelopmentFileInput" className="UpdateAttLabText">
                                    <IoIosAdd className='IoIosAddAttach' />
                                </label>
                            </BootstrapTooltip>
                        </Button> */}

                        {DevAttachImgFiles && DevAttachImgFiles.length > 0 &&
                            <Button
                                variant="contained"
                                onClick={() => AttachSave(DevConvertedAttachs, Data.ComplaintIDPK, 7)}
                                className="TaskDetAdmUpdateBtn"
                            >
                                Save Attachments
                            </Button>}

                    </div>

                    {DevAttachImgFiles && DevAttachImgFiles.length > 0 &&
                        <div className="IssueImgFileList">
                            {DevAttachImgFiles.map((file) => (
                                <div key={file.name} className="IssueTaskDetFileItem" onDoubleClick={() => handleFilePreview(file)}>
                                    <div className="TaskDetFileName">{file.name}</div>
                                    <AiOutlineClose className="TaskDetCloseIcon" onClick={() => DevAttactRemoves(file.name)} />
                                </div>
                            ))}
                        </div>}

                    {DevAttachDatasView && DevAttachDatas &&
                        <div className="AttachDataSection">
                            {DevAttachDatasView && DevAttachDatas && DevAttachDatas.map((val) => {
                                return (
                                    <div className="AttachDataDiv" key={val.ImageName}>
                                        <div className="AttachImgSection">
                                            {["jpg", "jpeg", "png"].includes(convertedImageName(val.ImgPath)) ?
                                                <img src={val.ImgPath} alt="Image" className="AttachImgStyle" />
                                                : ["pdf"].includes(convertedImageName(val.ImgPath)) ?
                                                    <div className="FileExtensionImgDiv"><PiFilePdfThin style={{ fontSize: "60px" }} /></div>
                                                    : ["txt"].includes(convertedImageName(val.ImgPath)) ?
                                                        <div className="FileExtensionImgDiv"><PiFileTxtThin style={{ fontSize: "60px" }} /></div>
                                                        : ["xlsx"].includes(convertedImageName(val.ImgPath)) ?
                                                            <div className="FileExtensionImgDiv"><PiFileXlsThin style={{ fontSize: "60px" }} /></div>
                                                            : ["docx"].includes(convertedImageName(val.ImgPath)) ?
                                                                <div className="FileExtensionImgDiv"><PiFileDocThin style={{ fontSize: "60px" }} /></div>
                                                                : ''}
                                        </div>
                                        <div className="AttachImgDetails">
                                            <BootstrapTooltip title={val.ImageName} placement="top-start">
                                                <span className="AttachImgName description-cell">{val.ImageName}</span>
                                            </BootstrapTooltip>
                                            <div className="AttachViewDiv" onClick={() => handleFilePreviewView(val)}>
                                                <MdRemoveRedEye style={{ width: '16px', height: "16px" }} />
                                                <span className="AttachViewtext">View</span>
                                            </div>
                                        </div>
                                    </div>);
                            })
                            }
                        </div>}

                    <TaskPoints ComplaintIDPK={Data.ComplaintIDPK} Modalloading={(e) => Modalloading(e)} TaskStatusIDPK={state.TaskStatusIDPK} />
                </div>

                <div className='ActivityLogSec'>
                    <ActivityLog ComplaintIDPK={Data.ComplaintIDPK} Modalloading={(e) => Modalloading(e)} TaskStatusIDPK={state.TaskStatusIDPK} />
                </div>
            </div>

        </div>
    )
}

export default View
